import { useState, useEffect } from "react";

// ui
import {
  Button,
  Typography,
  Modal,
  Box,
  TextField,
  Paper,
  Alert,
  FormControl,
  Select,
  InputLabel,
  MenuItem,
  Checkbox,
  FormHelperText,
  Autocomplete,
} from "@mui/material";
import { styled } from "@mui/system";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

// jotai
import { useAtomValue } from "jotai";
import { AppAtoms } from "../lib/store";

import { LIST_POST } from "../config/const";

const CustomTextField = styled(TextField)({
  "& .MuiInputBase-input": {
    fontSize: "12px",
    height: "12px", // ここでフォントサイズを指定
  },
});
CustomTextField.defaultProps = {
  autoComplete: "off",
};

interface GetXLSXTossUpModalProps {
  onModal: boolean;
  swCloseModal: () => void;
  getXLSXStatus: {
    status: "none" | "open" | "getting" | "result" | "loading" | "error";
    message: string;
    toss_up_state: number[];
    all_toss_up_state: boolean;
    category_id_list: number[];
    all_category: boolean;
    sale_company_id: number | null;
    sale_company_name: string;
    all_company: boolean;
    product_id: number | null;
    product_name: string;
    all_product: boolean;
    toss_up_start_year: string;
    toss_up_start_month: string;
    toss_up_end_year: string;
    toss_up_end_month: string;
    toss_up_all_year: boolean;
    closing_start_year: string;
    closing_start_month: string;
    closing_end_year: string;
    closing_end_month: string;
    closing_all_year: boolean;
    hope_call_start_year: string;
    hope_call_start_month: string;
    hope_call_end_year: string;
    hope_call_end_month: string;
    hope_call_all_year: boolean;
  };
  setGetXLSXStatus: (getXLSXStatus: {
    status: "none" | "open" | "getting" | "result" | "loading" | "error";
    message: string;
    toss_up_state: number[];
    all_toss_up_state: boolean;
    category_id_list: number[];
    all_category: boolean;
    sale_company_id: number | null;
    sale_company_name: string;
    all_company: boolean;
    product_id: number | null;
    product_name: string;
    all_product: boolean;
    toss_up_start_year: string;
    toss_up_start_month: string;
    toss_up_end_year: string;
    toss_up_end_month: string;
    toss_up_all_year: boolean;
    closing_start_year: string;
    closing_start_month: string;
    closing_end_year: string;
    closing_end_month: string;
    closing_all_year: boolean;
    hope_call_start_year: string;
    hope_call_start_month: string;
    hope_call_end_year: string;
    hope_call_end_month: string;
    hope_call_all_year: boolean;
  }) => void;
  getXLSXFunc: () => void;
  firstYear: number;
  thisYear: number;
  thisMonth: number;
  lastYear: number;
  lastMonth: number;
  companyList: { id: number; sale_company_name: string }[];
  productList: {
    id: number;
    high_rank_company_id: number;
    product_name: string;
    high_rank_company_name: string;
  }[];
  categoryList: { id: number; category_name: string }[];
}

export function GetXLSXTossUpModal(props: GetXLSXTossUpModalProps) {
  const {
    onModal,
    swCloseModal,
    getXLSXStatus,
    setGetXLSXStatus,
    getXLSXFunc,
    firstYear,
    thisYear,
    thisMonth,
    lastYear,
    lastMonth,
    companyList,
    productList,
    categoryList,
  } = props;

  const loginUser = useAtomValue(AppAtoms.loginUser);

  const createMonthList = () => {
    let monthList = [];
    for (let i = 1; i <= 12; i++) {
      monthList.push(i.toString());
    }
    return monthList;
  };
  const createYearList = () => {
    let yearList = [];
    for (let i = firstYear; i <= thisYear; i++) {
      yearList.push(i.toString());
    }
    return yearList;
  };
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 800,
    maxHeight: "70vh",
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };
  const [postCSVProductName, setPostCSVProductName] = useState<string>("");
  const autocompleteProductList: string[] = productList.map((product) => {
    return product.high_rank_company_name === "-"
      ? product.product_name
      : product.high_rank_company_name + "/" + product.product_name;
  });
  useEffect(() => {
    let productID: null | number = null;
    let productName: string = "";
    productList.map((product) => {
      const _postCSVProductName =
        product.high_rank_company_name === "-"
          ? product.product_name
          : product.high_rank_company_name + "/" + product.product_name;
      if (postCSVProductName === _postCSVProductName) {
        productID = product.id;
        productName = product.product_name;
      }
    });
    if (productID) {
      setGetXLSXStatus({
        ...getXLSXStatus,
        product_id: productID,
        product_name: productName,
      });
    }
  }, [postCSVProductName]);

  const [postCSVSaleCompanyName, setPostCSVSaleCompanyName] =
    useState<string>("");
  const autocompleteSaleCompanyList: string[] = companyList.map(
    (saleCompany) => {
      return saleCompany.sale_company_name;
    }
  );
  useEffect(() => {
    let saleCompanyID: null | number = null;
    let saleCompanyName: string = "";
    companyList.map((saleCompany) => {
      if (postCSVSaleCompanyName === saleCompany.sale_company_name) {
        saleCompanyID = saleCompany.id;
        saleCompanyName = saleCompany.sale_company_name;
      }
    });
    if (saleCompanyID) {
      setGetXLSXStatus({
        ...getXLSXStatus,
        sale_company_id: saleCompanyID,
        sale_company_name: saleCompanyName,
      });
    }
  }, [postCSVSaleCompanyName]);

  function closeModal() {
    setPostCSVProductName("");
    setPostCSVSaleCompanyName("");
    swCloseModal();
  }
  return (
    <Modal
      open={onModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Typography id="modal-modal-title" variant="h6" component="h2">
          トスアップ一覧出力
        </Typography>
        {getXLSXStatus.status === "open" ? (
          <Typography id="modal-modal-description" sx={{ mt: 2, mb: 5 }}>
            <Paper elevation={1}>
              <Box sx={{ maxHeight: "calc(70vh - 80px)", overflowY: "auto" }}>
                <Box key={"tossUpStatus"} sx={{ margin: "30px 0px" }}>
                  <FormControl
                    sx={{
                      marginLeft: "30px",
                      marginTop: "10px",
                      width: "585px",
                    }}
                  >
                    ステータス
                  </FormControl>
                  全ステータス
                  <Checkbox
                    checked={getXLSXStatus.all_toss_up_state}
                    onClick={() => {
                      setGetXLSXStatus({
                        ...getXLSXStatus,
                        all_toss_up_state: !getXLSXStatus.all_toss_up_state,
                      });
                    }}
                  />
                  {getXLSXStatus.all_toss_up_state ? null : (
                    <Box
                      sx={{
                        display: "flex",
                        flexWrap: "wrap",
                        marginTop: "10px",
                        marginBottom: "20px",
                        marginLeft: "30px",
                        width: "calc(100% - 40px)",
                      }}
                    >
                      {LIST_POST.toss_up_status.map((toss_up_status) => {
                        return (
                          <Box
                            className="serch-label"
                            sx={{ marginRight: "25px" }}
                          >
                            <Checkbox
                              sx={{
                                "& .MuiSvgIcon-root": { fontSize: 16 },
                                marginTop: "-5px",
                              }}
                              checked={getXLSXStatus.toss_up_state.includes(
                                toss_up_status.id
                              )}
                              onClick={() => {
                                let _toss_up_status =
                                  getXLSXStatus.toss_up_state.concat();
                                if (
                                  getXLSXStatus.toss_up_state.includes(
                                    toss_up_status.id
                                  )
                                ) {
                                  _toss_up_status = _toss_up_status.filter(
                                    (_toss_up_status_id) =>
                                      _toss_up_status_id !== toss_up_status.id
                                  );
                                } else {
                                  _toss_up_status.push(toss_up_status.id);
                                }
                                setGetXLSXStatus({
                                  ...getXLSXStatus,
                                  toss_up_state: _toss_up_status,
                                });
                              }}
                            />
                            {toss_up_status.value}
                          </Box>
                        );
                      })}
                    </Box>
                  )}
                </Box>
                <Box key={"tossUpCategori"} sx={{ margin: "30px 0px" }}>
                  <FormControl
                    sx={{
                      marginLeft: "30px",
                      marginTop: "10px",
                      width: "600px",
                    }}
                  >
                    カテゴリ
                  </FormControl>
                  全カテゴリ
                  <Checkbox
                    checked={getXLSXStatus.all_category}
                    onClick={() => {
                      setGetXLSXStatus({
                        ...getXLSXStatus,
                        all_category: !getXLSXStatus.all_category,
                      });
                    }}
                  />
                  {getXLSXStatus.all_category ? null : (
                    <Box
                      sx={{
                        display: "flex",
                        flexWrap: "wrap",
                        marginTop: "10px",
                        marginBottom: "20px",
                        marginLeft: "30px",
                        width: "calc(100% - 40px)",
                      }}
                    >
                      {categoryList.map((category) => {
                        return (
                          <Box
                            className="serch-label"
                            sx={{ marginRight: "25px" }}
                          >
                            <Checkbox
                              sx={{
                                "& .MuiSvgIcon-root": { fontSize: 16 },
                                marginTop: "-5px",
                              }}
                              checked={getXLSXStatus.category_id_list.includes(
                                category.id
                              )}
                              onClick={() => {
                                let _category_id_list =
                                  getXLSXStatus.category_id_list.concat();
                                if (
                                  getXLSXStatus.category_id_list.includes(
                                    category.id
                                  )
                                ) {
                                  _category_id_list = _category_id_list.filter(
                                    (_category_id_list_id) =>
                                      _category_id_list_id !== category.id
                                  );
                                } else {
                                  _category_id_list.push(category.id);
                                }
                                setGetXLSXStatus({
                                  ...getXLSXStatus,
                                  category_id_list: _category_id_list,
                                });
                              }}
                            />
                            {category.category_name}
                          </Box>
                        );
                      })}
                    </Box>
                  )}
                </Box>
                <Box key={"paymentElsxProduct"} sx={{ margin: "30px 0px" }}>
                  <FormControl
                    sx={{
                      marginLeft: "30px",
                      marginTop: "10px",
                      width: "635px",
                    }}
                  >
                    商材
                  </FormControl>
                  全商材
                  <Checkbox
                    checked={getXLSXStatus.all_product}
                    onClick={() => {
                      setGetXLSXStatus({
                        ...getXLSXStatus,
                        all_product: !getXLSXStatus.all_product,
                      });
                    }}
                  />
                  {getXLSXStatus.all_product ? null : (
                    <FormControl sx={{ width: "520px", marginLeft: "230px" }}>
                      <Autocomplete
                        sx={{
                          height: "30px",
                          textAlign: "end",
                        }}
                        clearIcon={null}
                        options={autocompleteProductList}
                        value={postCSVProductName}
                        onChange={(event: any, newValue: string | null) => {
                          if (newValue) {
                            setPostCSVProductName(newValue);
                          }
                        }}
                        renderInput={(params) => (
                          <TextField
                            value={postCSVProductName}
                            sx={{
                              "& .MuiInputBase-root": {
                                fontSize: "16px",
                                height: "32px",
                              },
                            }}
                            {...params}
                          />
                        )}
                      />
                    </FormControl>
                  )}
                </Box>
                {loginUser?.authority !== "パートナー" &&
                loginUser?.authority !== "営業アカウント" ? (
                  <Box
                    key={"paymentElsxSaleCompany"}
                    sx={{ margin: "30px 0px" }}
                  >
                    <FormControl
                      sx={{
                        marginLeft: "30px",
                        marginTop: "10px",
                        width: "585px",
                      }}
                    >
                      トスアップパートナー
                    </FormControl>
                    全パートナー
                    <Checkbox
                      checked={getXLSXStatus.all_company}
                      onClick={() => {
                        setGetXLSXStatus({
                          ...getXLSXStatus,
                          all_company: !getXLSXStatus.all_company,
                        });
                      }}
                    />
                    {getXLSXStatus.all_company ? null : (
                      <FormControl sx={{ width: "520px", marginLeft: "230px" }}>
                        <Autocomplete
                          sx={{
                            height: "30px",
                            textAlign: "end",
                          }}
                          clearIcon={null}
                          options={autocompleteSaleCompanyList}
                          value={postCSVSaleCompanyName}
                          onChange={(event: any, newValue: string | null) => {
                            if (newValue) {
                              setPostCSVSaleCompanyName(newValue);
                            }
                          }}
                          renderInput={(params) => (
                            <TextField
                              value={postCSVSaleCompanyName}
                              sx={{
                                "& .MuiInputBase-root": {
                                  fontSize: "16px",
                                  height: "32px",
                                },
                              }}
                              {...params}
                            />
                          )}
                        />
                      </FormControl>
                    )}
                  </Box>
                ) : null}
                <Box
                  key={"toss_up_paymentElsxBoxYear"}
                  sx={{ margin: "30px 0px" }}
                >
                  <FormControl
                    sx={{
                      marginLeft: "30px",
                      marginTop: "10px",
                      width: "600px",
                    }}
                  >
                    トスアップ日
                  </FormControl>
                  検索しない
                  <Checkbox
                    checked={getXLSXStatus.toss_up_all_year}
                    onClick={() => {
                      setGetXLSXStatus({
                        ...getXLSXStatus,
                        toss_up_all_year: !getXLSXStatus.toss_up_all_year,
                      });
                    }}
                  />
                </Box>
                {getXLSXStatus.toss_up_all_year ? null : (
                  <Box
                    key={"toss_up_paymentElsxBoxYear2"}
                    sx={{ margin: "15px 0px" }}
                  >
                    <FormControl sx={{ width: "150px", marginLeft: "130px" }}>
                      <InputLabel id="serch-input-label">年</InputLabel>
                      <Select
                        disabled={getXLSXStatus.toss_up_all_year}
                        labelId="serch-input-label"
                        id="serch-input"
                        value={getXLSXStatus.toss_up_start_year}
                        label={"年"}
                        onChange={(e) =>
                          setGetXLSXStatus({
                            ...getXLSXStatus,
                            toss_up_start_year: e.target.value,
                          })
                        }
                        sx={{
                          height: "30px",
                          textAlign: "end",
                        }}
                      >
                        {createYearList().map((input, i) => {
                          return (
                            <MenuItem
                              key={"input" + i}
                              value={input}
                              sx={{ textAlign: "right" }}
                            >
                              {input}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                    <FormControl sx={{ width: "80px", marginLeft: "30px" }}>
                      <InputLabel id="serch-input-label">月</InputLabel>
                      <Select
                        disabled={getXLSXStatus.toss_up_all_year}
                        labelId="serch-input-label"
                        id="serch-input"
                        value={getXLSXStatus.toss_up_start_month}
                        label={"月"}
                        onChange={(e) =>
                          setGetXLSXStatus({
                            ...getXLSXStatus,
                            toss_up_start_month: e.target.value,
                          })
                        }
                        sx={{
                          height: "30px",
                          textAlign: "end",
                        }}
                      >
                        {createMonthList().map((input, i) => {
                          return (
                            <MenuItem
                              key={"input" + i}
                              value={input}
                              sx={{ textAlign: "right" }}
                            >
                              {input}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                    <FormControl sx={{ width: "50px", marginLeft: "45px" }}>
                      ~
                    </FormControl>
                    <FormControl sx={{ width: "150px" }}>
                      <InputLabel id="serch-input-label">年</InputLabel>
                      <Select
                        disabled={getXLSXStatus.toss_up_all_year}
                        labelId="serch-input-label"
                        id="serch-input"
                        value={getXLSXStatus.toss_up_end_year}
                        label={"年"}
                        onChange={(e) =>
                          setGetXLSXStatus({
                            ...getXLSXStatus,
                            toss_up_end_year: e.target.value,
                          })
                        }
                        sx={{
                          height: "30px",
                          textAlign: "end",
                        }}
                      >
                        {createYearList().map((input, i) => {
                          return (
                            <MenuItem
                              key={"input" + i}
                              value={input}
                              sx={{ textAlign: "right" }}
                            >
                              {input}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                    <FormControl sx={{ width: "80px", marginLeft: "30px" }}>
                      <InputLabel id="serch-input-label">月</InputLabel>
                      <Select
                        disabled={getXLSXStatus.toss_up_all_year}
                        labelId="serch-input-label"
                        id="serch-input"
                        value={getXLSXStatus.toss_up_end_month}
                        label={"月"}
                        onChange={(e) =>
                          setGetXLSXStatus({
                            ...getXLSXStatus,
                            toss_up_end_month: e.target.value,
                          })
                        }
                        sx={{
                          height: "30px",
                          textAlign: "end",
                        }}
                      >
                        {createMonthList().map((input, i) => {
                          return (
                            <MenuItem
                              key={"input" + i}
                              value={input}
                              sx={{ textAlign: "right" }}
                            >
                              {input}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </Box>
                )}
                <Box
                  key={"closing_paymentElsxBoxYear"}
                  sx={{ margin: "30px 0px" }}
                >
                  <FormControl
                    sx={{
                      marginLeft: "30px",
                      marginTop: "10px",
                      width: "600px",
                    }}
                  >
                    架電・クロージング日
                  </FormControl>
                  検索しない
                  <Checkbox
                    checked={getXLSXStatus.closing_all_year}
                    onClick={() => {
                      setGetXLSXStatus({
                        ...getXLSXStatus,
                        closing_all_year: !getXLSXStatus.closing_all_year,
                      });
                    }}
                  />
                </Box>
                {getXLSXStatus.closing_all_year ? null : (
                  <Box
                    key={"closing_paymentElsxBoxYear2"}
                    sx={{ margin: "15px 0px" }}
                  >
                    <FormControl sx={{ width: "150px", marginLeft: "130px" }}>
                      <InputLabel id="serch-input-label">年</InputLabel>
                      <Select
                        disabled={getXLSXStatus.closing_all_year}
                        labelId="serch-input-label"
                        id="serch-input"
                        value={getXLSXStatus.closing_start_year}
                        label={"年"}
                        onChange={(e) =>
                          setGetXLSXStatus({
                            ...getXLSXStatus,
                            closing_start_year: e.target.value,
                          })
                        }
                        sx={{
                          height: "30px",
                          textAlign: "end",
                        }}
                      >
                        {createYearList().map((input, i) => {
                          return (
                            <MenuItem
                              key={"input" + i}
                              value={input}
                              sx={{ textAlign: "right" }}
                            >
                              {input}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                    <FormControl sx={{ width: "80px", marginLeft: "30px" }}>
                      <InputLabel id="serch-input-label">月</InputLabel>
                      <Select
                        disabled={getXLSXStatus.closing_all_year}
                        labelId="serch-input-label"
                        id="serch-input"
                        value={getXLSXStatus.closing_start_month}
                        label={"月"}
                        onChange={(e) =>
                          setGetXLSXStatus({
                            ...getXLSXStatus,
                            closing_start_month: e.target.value,
                          })
                        }
                        sx={{
                          height: "30px",
                          textAlign: "end",
                        }}
                      >
                        {createMonthList().map((input, i) => {
                          return (
                            <MenuItem
                              key={"input" + i}
                              value={input}
                              sx={{ textAlign: "right" }}
                            >
                              {input}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                    <FormControl sx={{ width: "50px", marginLeft: "45px" }}>
                      ~
                    </FormControl>
                    <FormControl sx={{ width: "150px" }}>
                      <InputLabel id="serch-input-label">年</InputLabel>
                      <Select
                        disabled={getXLSXStatus.closing_all_year}
                        labelId="serch-input-label"
                        id="serch-input"
                        value={getXLSXStatus.closing_end_year}
                        label={"年"}
                        onChange={(e) =>
                          setGetXLSXStatus({
                            ...getXLSXStatus,
                            closing_end_year: e.target.value,
                          })
                        }
                        sx={{
                          height: "30px",
                          textAlign: "end",
                        }}
                      >
                        {createYearList().map((input, i) => {
                          return (
                            <MenuItem
                              key={"input" + i}
                              value={input}
                              sx={{ textAlign: "right" }}
                            >
                              {input}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                    <FormControl sx={{ width: "80px", marginLeft: "30px" }}>
                      <InputLabel id="serch-input-label">月</InputLabel>
                      <Select
                        disabled={getXLSXStatus.closing_all_year}
                        labelId="serch-input-label"
                        id="serch-input"
                        value={getXLSXStatus.closing_end_month}
                        label={"月"}
                        onChange={(e) =>
                          setGetXLSXStatus({
                            ...getXLSXStatus,
                            closing_end_month: e.target.value,
                          })
                        }
                        sx={{
                          height: "30px",
                          textAlign: "end",
                        }}
                      >
                        {createMonthList().map((input, i) => {
                          return (
                            <MenuItem
                              key={"input" + i}
                              value={input}
                              sx={{ textAlign: "right" }}
                            >
                              {input}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </Box>
                )}
                <Box
                  key={"hope_call_paymentElsxBoxYear"}
                  sx={{ margin: "30px 0px" }}
                >
                  <FormControl
                    sx={{
                      marginLeft: "30px",
                      marginTop: "10px",
                      width: "600px",
                    }}
                  >
                    架電希望日
                  </FormControl>
                  検索しない
                  <Checkbox
                    checked={getXLSXStatus.hope_call_all_year}
                    onClick={() => {
                      setGetXLSXStatus({
                        ...getXLSXStatus,
                        hope_call_all_year: !getXLSXStatus.hope_call_all_year,
                      });
                    }}
                  />
                </Box>
                {getXLSXStatus.hope_call_all_year ? null : (
                  <Box
                    key={"hope_call_paymentElsxBoxYear2"}
                    sx={{ margin: "15px 0px" }}
                  >
                    <FormControl sx={{ width: "150px", marginLeft: "130px" }}>
                      <InputLabel id="serch-input-label">年</InputLabel>
                      <Select
                        disabled={getXLSXStatus.hope_call_all_year}
                        labelId="serch-input-label"
                        id="serch-input"
                        value={getXLSXStatus.hope_call_start_year}
                        label={"年"}
                        onChange={(e) =>
                          setGetXLSXStatus({
                            ...getXLSXStatus,
                            hope_call_start_year: e.target.value,
                          })
                        }
                        sx={{
                          height: "30px",
                          textAlign: "end",
                        }}
                      >
                        {createYearList().map((input, i) => {
                          return (
                            <MenuItem
                              key={"input" + i}
                              value={input}
                              sx={{ textAlign: "right" }}
                            >
                              {input}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                    <FormControl sx={{ width: "80px", marginLeft: "30px" }}>
                      <InputLabel id="serch-input-label">月</InputLabel>
                      <Select
                        disabled={getXLSXStatus.hope_call_all_year}
                        labelId="serch-input-label"
                        id="serch-input"
                        value={getXLSXStatus.hope_call_start_month}
                        label={"月"}
                        onChange={(e) =>
                          setGetXLSXStatus({
                            ...getXLSXStatus,
                            hope_call_start_month: e.target.value,
                          })
                        }
                        sx={{
                          height: "30px",
                          textAlign: "end",
                        }}
                      >
                        {createMonthList().map((input, i) => {
                          return (
                            <MenuItem
                              key={"input" + i}
                              value={input}
                              sx={{ textAlign: "right" }}
                            >
                              {input}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                    <FormControl sx={{ width: "50px", marginLeft: "45px" }}>
                      ~
                    </FormControl>
                    <FormControl sx={{ width: "150px" }}>
                      <InputLabel id="serch-input-label">年</InputLabel>
                      <Select
                        disabled={getXLSXStatus.hope_call_all_year}
                        labelId="serch-input-label"
                        id="serch-input"
                        value={getXLSXStatus.hope_call_end_year}
                        label={"年"}
                        onChange={(e) =>
                          setGetXLSXStatus({
                            ...getXLSXStatus,
                            hope_call_end_year: e.target.value,
                          })
                        }
                        sx={{
                          height: "30px",
                          textAlign: "end",
                        }}
                      >
                        {createYearList().map((input, i) => {
                          return (
                            <MenuItem
                              key={"input" + i}
                              value={input}
                              sx={{ textAlign: "right" }}
                            >
                              {input}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                    <FormControl sx={{ width: "80px", marginLeft: "30px" }}>
                      <InputLabel id="serch-input-label">月</InputLabel>
                      <Select
                        disabled={getXLSXStatus.hope_call_all_year}
                        labelId="serch-input-label"
                        id="serch-input"
                        value={getXLSXStatus.hope_call_end_month}
                        label={"月"}
                        onChange={(e) =>
                          setGetXLSXStatus({
                            ...getXLSXStatus,
                            hope_call_end_month: e.target.value,
                          })
                        }
                        sx={{
                          height: "30px",
                          textAlign: "end",
                        }}
                      >
                        {createMonthList().map((input, i) => {
                          return (
                            <MenuItem
                              key={"input" + i}
                              value={input}
                              sx={{ textAlign: "right" }}
                            >
                              {input}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </Box>
                )}
              </Box>
            </Paper>
            <Box>
              <Button
                disabled={
                  (loginUser?.authority !== "パートナー" &&
                    loginUser?.authority !== "営業アカウント" &&
                    getXLSXStatus.sale_company_id === null &&
                    !getXLSXStatus.all_company) ||
                  (getXLSXStatus.product_id === null &&
                    !getXLSXStatus.all_product) ||
                  (getXLSXStatus.category_id_list.length === 0 &&
                    !getXLSXStatus.all_category) ||
                  (getXLSXStatus.toss_up_state.length === 0 &&
                    !getXLSXStatus.all_toss_up_state)
                }
                variant="outlined"
                style={{
                  marginTop: "15px",
                  height: "40px",
                  position: "absolute",
                  right: "205px",
                  width: "200px",
                  fontSize: "20px",
                }}
                onClick={() => {
                  getXLSXFunc();
                  setGetXLSXStatus({
                    ...getXLSXStatus,
                    status: "loading",
                  });
                }}
              >
                <Box className="m-plus-rounded-1c-modal">一覧出力</Box>
                <FileDownloadIcon
                  sx={{ marginLeft: "6px" }}
                  fontSize="medium"
                />
              </Button>
              <Button
                variant="outlined"
                style={{
                  marginTop: "15px",
                  height: "40px",
                  position: "absolute",
                  right: "35px",
                  width: "160px",
                  fontSize: "20px",
                }}
                onClick={swCloseModal}
              >
                <Box className="m-plus-rounded-1c-modal">キャンセル</Box>
              </Button>
            </Box>
          </Typography>
        ) : getXLSXStatus.status === "loading" ? (
          <Typography id="modal-modal-description" sx={{ mt: 2, mb: 5 }}>
            <Box sx={{ textAlign: "center" }}>トスアップ一覧作成準備中</Box>
          </Typography>
        ) : getXLSXStatus.status === "getting" ? (
          <Typography id="modal-modal-description" sx={{ mt: 2, mb: 5 }}>
            <Box sx={{ textAlign: "center" }}>{getXLSXStatus.message}</Box>
          </Typography>
        ) : getXLSXStatus.status === "error" ? (
          <Typography id="modal-modal-description" sx={{ mt: 2, mb: 5 }}>
            <Alert severity="error">
              <Box>トスアップ一覧出力に失敗しました。</Box>
            </Alert>
            <Button
              variant="outlined"
              style={{
                marginTop: "15px",
                height: "40px",
                position: "absolute",
                right: "45px",
                width: "160px",
                fontSize: "20px",
              }}
              onClick={() =>
                setGetXLSXStatus({
                  status: "open",
                  message: "",
                  toss_up_state: [],
                  all_toss_up_state: false,
                  category_id_list: [],
                  all_category: false,
                  sale_company_id: null,
                  sale_company_name: "",
                  all_company: true,
                  product_id: null,
                  product_name: "",
                  all_product: true,
                  toss_up_start_year: lastYear.toString(),
                  toss_up_start_month: lastMonth.toString(),
                  toss_up_end_year: thisYear.toString(),
                  toss_up_end_month: thisMonth.toString(),
                  toss_up_all_year: false,
                  closing_start_year: lastYear.toString(),
                  closing_start_month: lastMonth.toString(),
                  closing_end_year: thisYear.toString(),
                  closing_end_month: thisMonth.toString(),
                  closing_all_year: true,
                  hope_call_start_year: lastYear.toString(),
                  hope_call_start_month: lastMonth.toString(),
                  hope_call_end_year: thisYear.toString(),
                  hope_call_end_month: thisMonth.toString(),
                  hope_call_all_year: true,
                })
              }
            >
              戻る
            </Button>
          </Typography>
        ) : getXLSXStatus.status === "result" ? (
          <Typography id="modal-modal-description" sx={{ mt: 2, mb: 5 }}>
            <Box>{getXLSXStatus.message}</Box>
            <Button
              variant="outlined"
              style={{
                marginTop: "15px",
                height: "40px",
                position: "absolute",
                right: "45px",
                width: "160px",
                fontSize: "20px",
              }}
              onClick={swCloseModal}
            >
              閉じる
            </Button>
          </Typography>
        ) : null}
      </Box>
    </Modal>
  );
}
